module.exports = __webpack_public_path__ + "static/img/recording_created.00272b7c.svg";